import { render, staticRenderFns } from "./MenuItemRow.vue?vue&type=template&id=68f966b2&scoped=true&"
import script from "./MenuItemRow.vue?vue&type=script&lang=js&"
export * from "./MenuItemRow.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemRow.vue?vue&type=style&index=0&id=68f966b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f966b2",
  null
  
)

export default component.exports